var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDairectMonogramMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 73 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -100,
    y: -100,
    width: 273,
    height: 280
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(50px)",
      clipPath: "url(#bgblur_0_605_134_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    "data-figma-bg-blur-radius": 100
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4774 78.3045L48.3596 0H24.6404L0.556584 78.1944L0 80H27.6542L36.5012 71.219L45.3482 80H73L72.4774 78.3045ZM36.5012 54.9832L12.923 78.2237L36.5012 1.69307L60.077 78.2237L36.5012 54.9832Z",
    fill: "var(--fill-0, white)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3457 0.5L36.0234 1.5459L12.4453 78.0762L13.2744 78.5801L36.501 55.6846L59.7256 78.5801L60.5547 78.0762L36.9795 1.5459L36.6572 0.5H47.9902L72 78.4512V78.4521L72.3232 79.5H45.5537L36.8535 70.8643L36.501 70.5146L36.1494 70.8643L27.4482 79.5H0.676758L1.03418 78.3418L25.0098 0.5H36.3457Z",
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_605_134_clip_path",
    transform: "translate(100 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4774 78.3045L48.3596 0H24.6404L0.556584 78.1944L0 80H27.6542L36.5012 71.219L45.3482 80H73L72.4774 78.3045ZM36.5012 54.9832L12.923 78.2237L36.5012 1.69307L60.077 78.2237L36.5012 54.9832Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairectMonogramMobile);
export default __webpack_public_path__ + "static/media/dairect-monogram-mobile.a7efad1d679fde5d7effb61fa9ef6f6f.svg";
export { ForwardRef as ReactComponent };